// Texty USP pásu v čase akcie na dopravu (benefitPromo.js, #322). SK akciu
// nemá (`shipping.promo: []`), texty sú kvôli parite kľúčov s CZ.
import { NBSP } from '../../modules/money.js';

export default {
  /** položka o doprave: titulok z adminu „Doprava od 2,99 €" (neoverené vo fixtures) */
  shipTitleRe: /doprava\s+od\s+\d/i,
  /** „Doprava od 0,79 €" (cena už s menou z money()) */
  promoTitle: (price) => 'Doprava od ' + price,
  /** „PPL na výdajné miesto do 10 kg, akcia do 25. 10." */
  promoText: (carrier, maxKg, until) => carrier + ' na výdajné miesto do ' + maxKg + NBSP + 'kg, akcia do ' + until,
};
